import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import "./MasteryZonesSection.css";

const MasteryZonesSection = () => {
  const masteryZones = [
    {
      title: "Digital Strategy & Consulting",
      subtitle: "",
      image:
        "https://images.unsplash.com/photo-1533750349088-cd871a92f312?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      category: "",
    },
    {
      title: "Social Media Management",
      subtitle: "",
      image:
        "https://images.unsplash.com/photo-1656164630621-8974e3a7e85c?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      category: "",
    },
    {
      title: "Influencer & Creator Marketing",
      subtitle: "",
      image:
        "https://images.unsplash.com/photo-1673767298248-b128f17f89af?q=80&w=2671&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      category: "",
    },
    {
      title: "Branding & Identity Design",
      subtitle: "",
      image:
        "https://images.unsplash.com/photo-1561070791-36c11767b26a?q=80&w=1364&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      category: "",
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5 },
    },
  };

  return (
    <section className="mastery-zones-section">
      <div className="mastery-zones-container">
        <motion.h2
          className="mastery-zones-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Our <span className="highlight">Mastery</span> Zones
        </motion.h2>

        <motion.div
          className="mastery-zones-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
        >
          {masteryZones.map((zone, index) => (
            <motion.div
              key={index}
              className="mastery-zone-card"
              variants={itemVariants}
              whileHover={{ y: -10, transition: { duration: 0.2 } }}
            >
              <div className="mastery-zone-image-container">
                <div
                  className="mastery-zone-image-placeholder"
                  style={{ backgroundImage: `url(${zone.image})` }}
                ></div>
                <div className="mastery-zone-overlay">
                  <div className="mastery-zone-category">{zone.category}</div>
                  <div className="mastery-zone-titles">
                    <h3 className="mastery-zone-title">{zone.title}</h3>
                    {zone.subtitle && (
                      <p className="mastery-zone-subtitle">{zone.subtitle}</p>
                    )}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        <div className="mastery-zones-see-all">
          <Link to="/services" className="see-all-button">
            Explore all digital marketing services
          </Link>
        </div>
      </div>
    </section>
  );
};

export default MasteryZonesSection;
